import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaperplane16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPaperplane16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.705 7.55a.5.5 0 0 1 0 .895l-8.996 4.497a.5.5 0 0 1-.716-.538l.727-3.907h4.033a.5.5 0 0 0 0-1H3.72l-.727-3.906a.5.5 0 0 1 .716-.539zm.447 1.79c1.106-.554 1.106-2.131 0-2.684L4.156 2.158c-1.108-.554-2.372.398-2.146 1.616l.77 4.132a.5.5 0 0 1 0 .183l-.77 4.132c-.226 1.218 1.038 2.17 2.146 1.616z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPaperplane16);
